import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Input, Button, AlertMessage } from '../components/StyledComponents';
import Logo from '../assets/images/lock.jpg';
import { useSetNewPasswordMutation } from '../../redux/apiSlice';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [setNewPasswordApi] = useSetNewPasswordMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      // The backend expects: { email, token, newPassword }
      const result = await setNewPasswordApi({ email, token, newPassword });
      // Accept both 'data' and successful status in 'error' (for non-2xx but successful reset)
      if (
        ('data' in result && result.data)
        || (result?.error?.status === 200 && typeof result?.error?.data === 'string' && result?.error?.data.toLowerCase().includes('reset'))
      ) {
        setSuccess('Password reset successful! Please log in with your new password.');
        setTimeout(() => navigate('/public/login'), 2000);
      } else if ('error' in result && result.error) {
        const errorMsg = result.error.data?.message || result.error.data || '';
        if (
          result?.error?.status === 200
          && typeof errorMsg === 'string'
          && errorMsg.toLowerCase().includes('reset')
        ) {
          setSuccess('Password reset successful! Please log in with your new password.');
          setTimeout(() => navigate('/public/login'), 2000);
        } else {
          setError(errorMsg || 'Failed to reset password.');
        }
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="h-screen">
      <div className="container h-full px-8 py-24 mx-auto">
        <div className="flex h-full flex-wrap items-center justify-center lg:justify-between">
          <div className="w-full md:mb-0 md:w-8/12 lg:w-6/12">
            <img
              src={Logo}
              className="w-full"
              alt="Reset Password Padlock"
            />
          </div>
          <div className="md:w-8/12 lg:ml-6 lg:w-5/12">
            <h2 className="text-2xl font-bold mb-4 text-center text-gray-800">Reset Password</h2>
            {error && (
              <AlertMessage alertType="error" message={error} />
            )}
            {success && (
              <>
                <AlertMessage alertType="success" message={success} />
                <Button
                  $primary
                  type="button"
                  btnText="Login Now"
                  onClick={() => navigate('/public/login')}
                  style={{ marginTop: '10px' }}
                />
              </>
            )}
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <Input
                type="password"
                id="newPassword"
                placeholder="New Password"
                value={newPassword}
                handleChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <Input
                type="password"
                id="confirmPassword"
                placeholder="Confirm New Password"
                value={confirmPassword}
                handleChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <Button
                $primary
                type="submit"
                btnText={loading ? 'Resetting...' : 'Reset Password'}
              />
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResetPassword;
